/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import {
  CONTACT_VIEW_PERMISSIONS,
  CONTACT_IMPORT_PERMISSIONS,
  CONTACT_EXPORT_PERMISSIONS,
} from '../../../constants/permissions';

const ContactsView = () => import('./components/ContactsView.vue');
const ContactManageView = () => import('./pages/ContactManageView.vue');
const ContactsDataHub = () => import('./pages/ContactsDataHub.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    name: 'contacts_dashboard',
    meta: {
      permissions: ['administrator', 'agent', CONTACT_VIEW_PERMISSIONS],
    },
    component: ContactsView,
  },
  // A rota mantem o nome e o caminho antigos de proposito: links ja compartilhados continuam
  // funcionando e caem na aba Importar. Quem so tem permissao de exportar tambem precisa
  // alcancar a tela, entao a permissao de exportacao entra aqui (a checagem e "qualquer uma") e
  // o proprio hub esconde as abas que o usuario nao pode usar.
  {
    path: frontendURL('accounts/:accountId/contacts/import'),
    name: 'contact_import_spreadsheet',
    meta: {
      permissions: [
        'administrator',
        CONTACT_IMPORT_PERMISSIONS,
        CONTACT_EXPORT_PERMISSIONS,
      ],
    },
    component: ContactsDataHub,
  },
  {
    path: frontendURL('accounts/:accountId/contacts/wallet'),
    name: 'contact_wallet',
    meta: {
      permissions: ['administrator', 'agent', CONTACT_VIEW_PERMISSIONS],
    },
    component: ContactsView,
    props: () => ({ isWalletView: true }),
  },
  {
    path: frontendURL('accounts/:accountId/contacts/custom_view/:id'),
    name: 'contacts_segments_dashboard',
    meta: {
      permissions: ['administrator', 'agent', CONTACT_VIEW_PERMISSIONS],
    },
    component: ContactsView,
    props: route => {
      return { segmentsId: route.params.id };
    },
  },
  {
    path: frontendURL('accounts/:accountId/labels/:label/contacts'),
    name: 'contacts_labels_dashboard',
    meta: {
      permissions: ['administrator', 'agent', CONTACT_VIEW_PERMISSIONS],
    },
    component: ContactsView,
    props: route => {
      return { label: route.params.label };
    },
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    name: 'contact_profile_dashboard',
    meta: {
      permissions: ['administrator', 'agent', CONTACT_VIEW_PERMISSIONS],
    },
    component: ContactManageView,
    props: route => {
      return { contactId: route.params.contactId };
    },
  },
];
